import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SwitchBtns from 'modules/Common/components/SwitchBtns';
import { connect } from 'react-redux';
import AdvertWrapper from "modules/Common/components/AdvertWrapper";

@connect(
  state => {
    return {
      match: state.football.match
    };
  }
)
export default class FootballLiveMatchTeams extends Component {

  static propTypes = {
    match: PropTypes.object,
    matchLabel: PropTypes.string,
    params: PropTypes.object,
    children: PropTypes.object
  }

  render() {
    const matchId = this.props.params.matchId;
    const match = this.props.match[matchId].match;
    return (
      <div className="football-match-teams">
        <SwitchBtns buttons={[
          {href: `/football/live/${matchId}/teams/home`, text: match.homeTeam.teamName},
          {href: `/football/live/${matchId}/teams/away`, text: match.awayTeam.teamName}
        ]}/>
        <section className="content">
          {React.cloneElement(this.props.children, { matchLabel: this.props.matchLabel })}
        </section>
        <AdvertWrapper ocSlot={["football", "leaderboard"]} additionalProperties={{view: "live"}} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballLiveMatchTeams.js